"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowedRole = exports.SpacePermissionType = exports.ConversationType = exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["MESSAGE"] = "message";
    NotificationType["MENTION"] = "mention";
    NotificationType["COMMENT"] = "comment";
    NotificationType["LIKE"] = "like";
    NotificationType["SYSTEM"] = "system";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var ConversationType;
(function (ConversationType) {
    ConversationType["SPACE"] = "space";
    ConversationType["PRIVATE"] = "private";
})(ConversationType || (exports.ConversationType = ConversationType = {}));
var SpacePermissionType;
(function (SpacePermissionType) {
    SpacePermissionType["POST_BLOG"] = "post_blog";
    SpacePermissionType["SEND_CHAT"] = "send_chat";
})(SpacePermissionType || (exports.SpacePermissionType = SpacePermissionType = {}));
var AllowedRole;
(function (AllowedRole) {
    AllowedRole["OWNER"] = "owner";
    AllowedRole["ADMIN"] = "admin";
    AllowedRole["MEMBER"] = "member";
    AllowedRole["EVERYONE"] = "everyone";
})(AllowedRole || (exports.AllowedRole = AllowedRole = {}));
